import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';

const endpoint = 'ums/v1/cms/restaurant-suppliers/branches';
export const syncRelationBranchesEndpointIdentifier = endpoint;

type TData = Record<string, any>;
type TError = AxiosError;
type TVariables = {
  restaurantId: number;
  supplierId: number;
  ids: number[];
};

type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useSyncRelationBranchesApi(options?: Options): ReturnType {
  const toast = useCustomToast();

  const mutationFn = async ({ restaurantId, supplierId, ids }: TVariables) => {
    try {
      const { data } = await http.put(endpoint, { restaurantId, supplierId, branchIds: ids });

      toast({
        description: 'Branches have been synced successfully',
        status: 'success',
      });

      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, { mutationKey: [endpoint], ...options });
}
